// extracted by mini-css-extract-plugin
export var divider = "_is-7";
export var itemsToggle = "_is-8";
export var mergeModal = "_is-1";
export var optionCard = "_is-4";
export var radioGroup = "_is-6";
export var radioOption = "_is-0";
export var selected = "_is-5";
export var shipmentOptions = "_is-2";
export var tableOptions = "_is-3";